<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Evidenza home page', route: '/backoffice/home-evidenza' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">EVIDENZA HOME PAGE</h1>
</section>

<section class="pb-16 mb-8 px-container">
    <form [formGroup]="formHome" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-8">
            <div class="w-full">
                <p-checkbox label="Usa contenuto personalizzato" formControlName="attivo" value="attivo" pTooltip="Se deselezionato, verrà mostrato lo spettacolo in evidenza oppure il video di default" tooltipPosition="top" />
            </div>

            <ng-container *ngIf="isAttivo">
                <div class="w-full">
                    <label>* Tipo contenuto</label>
                    <p-dropdown [options]="tipi" optionLabel="label" optionValue="value" placeholder="Seleziona il tipo di contenuto" formControlName="tipo"></p-dropdown>
                </div>

                <div class="w-full" *ngIf="isVideo">
                    <app-file-upload [form]="formHome" [control]="'video'" [label]="'Video'" [multiple]="false" [accept]="'video/*,.mp4,.mov'" [text]="'Seleziona un video'"></app-file-upload>
                    <small class="text-slate-500 block mt-2">Il video verrà riprodotto in loop con pulsante per attivare l'audio.</small>
                </div>

                <ng-container *ngIf="isImmagine">
                    <div class="w-full">
                        <app-file-upload [form]="formHome" [control]="'immagine'" [label]="'Immagine'" [multiple]="false" [accept]="'image/*'" [text]="'Seleziona un\'immagine'"></app-file-upload>
                    </div>
                    <div class="w-full">
                        <label>Testo</label>
                        <p-editor [style]="{ height: '150px' }" formControlName="testo" />
                    </div>
                </ng-container>

                <div class="w-full pt-4 border-t border-slate-200">
                    <h2 class="text-lg font-medium mb-4">Pulsante</h2>
                    <div class="flex flex-col gap-8">
                        <div class="w-full">
                            <label>Testo pulsante</label>
                            <input type="text" pInputText placeholder="Testo pulsante" formControlName="testo_link" />
                        </div>
                        <div class="w-full">
                            <label>Azione pulsante</label>
                            <p-dropdown [options]="tipiPulsante" optionLabel="label" optionValue="value" placeholder="Seleziona l'azione del pulsante" formControlName="tipo_pulsante"></p-dropdown>
                        </div>
                        <div class="w-full" *ngIf="isPulsanteLink">
                            <label>Link</label>
                            <input type="text" pInputText placeholder="https://..." formControlName="link" />
                        </div>
                        <div class="w-full" *ngIf="isPulsanteFile">
                            <app-file-upload [form]="formHome" [control]="'file'" [label]="'File da scaricare'" [multiple]="false" [accept]="'application/pdf,.doc,.docx'" [text]="'Seleziona un file'"></app-file-upload>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <button class="btn-outln-backoffice p-3 w-full font-medium mt-8" type="submit" [disabled]="!formHome.valid">Salva modifiche</button>
    </form>
</section>
